import { OlliCartConfirmationUrl, OlliCartFeeSummaryUrl, CheckoutSummaryAgreementCheckBoxError } from "../directives/utilities/urls";
export default function olliCartSummary() {
    return {
        olliCartSummary:[] ,      
        showErrorMesage: "",
        isSuccess: false,
        message: "Loading please wait...",
        showLoader: false,
        total_Amount: '',
        isSubmitting: false,
        profileList: '',
        peopleList: '',
        addressDetails: '',
        people: '',
        waitListCoursesList: [],
        selectedAgreementChecked: false,
        olliFeeSummaryUrl:OlliCartFeeSummaryUrl,
        validateNextStep() {
            if (this.selectedAgreementChecked == false) {
                this.message = CheckoutSummaryAgreementCheckBoxError;
                return false;

            } else {
                document.getElementById('btnSubmit').click();
            }
        },
        bindCartList() {
           
            this.showLoader = true;
            this.waitlistCartList = [];
            this.enrollmentCartList = [];
            fetch("/api/OlliCheckout/LoadCheckout", {
                method: "get",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                }
            })
                .then((response) => {

                    return response.json();
                })
                .then((response) => {
                    this.message = "";
                    this.showLoader = false;
                    this.isSuccess = response.isSuccess;
                    if (response != undefined && response.isSuccess) {

                        this.olliCartSummary = response;
                        if (response.transcripts.length > 0) {

                            this.addressDetails = response.address;
                            this.total_Amount = response.transcripts.reduce((sum, item) => sum += item.fee, 0);
                            Array.prototype.push.apply(this.enrollmentCartList, response.transcripts);
                        } else {
                            this.showErrorMesage = "Your cart is empty.";
                        }
                    } else {  
                        this.message = "Error: ";
                        this.message = this.message + (response.messages.length > 0 ? response.messages.join(', ') : response.message);
                    }
                });
        },

        nextStep() {

            this.isSubmitting = true;

            fetch('/api/OlliCheckout/CompleteCheckout', {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    AgreementChecked: true,
                    SecurityCode: 111,
                    IpAddress: document.getElementById('ipAddress').value
                })
            }).then(response => {
                return response.json();
            }).then(result => {
                document.getElementsByClassName("f-button is-close-btn")[0].click();
                if (result.isSuccess && result.checkoutConfirmed) {
                    document.location.href = OlliCartConfirmationUrl; 
                }
                else {
                    this.message = result.message;
                    document.getElementById('btnFailedMessage').click();
                }
                this.isSubmitting = false;
       
            })
        },
    
        btnCancelClick() {
            document.location.href = '/api/login/SignOut';
        },
        
          formatDate(dateValue) {
            const date = new Date(dateValue);
            const month = date.getMonth() + 1; // Month is zero-based, so add 1
            const day = date.getDate();
            const year = date.getFullYear();
            return `${month}/${day}/${year}`;
        },
        init() {            
            this.bindCartList();
        },
    };
}
